import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'semantic-ui-react'

export default function DeleteUserModalContent({ close, onDelete, loading }) {
  return (
    <React.Fragment>
      <Modal.Header>Remove from workspace</Modal.Header>
      <Modal.Content>
        This user will lose access to this workspace, but their account and access to any other
        workspaces will remain.
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button negative onClick={onDelete} loading={loading} disabled={loading}>
          Remove from workspace
        </Button>
      </Modal.Actions>
    </React.Fragment>
  )
}

DeleteUserModalContent.propTypes = {
  close: PropTypes.func,
  onDelete: PropTypes.func,
  loading: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/DeleteUserModalContent/index.js